export { default as Wallet } from './wallet';
export * as TestUtils from './test-utils';
